import type { LocationType } from './schemas'

/**
 * Types proposés pour un nouveau rangement, le plus probable d'abord (site et appli) : un lieu à la racine, une
 * pièce dans un lieu, un meuble dans une pièce, un rangement (boîte, tiroir, étagère) ailleurs. L'API accepte tout
 * type à tout niveau ; on n'impose rien, on guide. Dépendances (garage, abri de jardin…) : collées à la maison, une
 * pièce du lieu ; bâtiment à part, un lieu (voir `inventory.outbuildingTip`).
 */
export function childTypesFor(parentType: LocationType | null): LocationType[] {
  switch (parentType) {
    case null:
      return ['place', 'room', 'storage']
    case 'place':
      // Un lieu dans un lieu : un bâtiment sur un terrain (maison, garage ou abri séparés).
      return ['room', 'place', 'furniture', 'storage']
    case 'room':
      return ['furniture', 'storage']
    default:
      return ['storage', 'furniture']
  }
}
